<template>
  <b-jumbotron class="header__page">
    <h1 class="text-uppercase">{{ title }}</h1>
    <h3 class="text-uppercase">{{ subtitle }}</h3>
  </b-jumbotron>
</template>

<script>
export default {
  props: ['title', 'subtitle'],
};
</script>

<style lang="scss" scoped>
.header__page {
  background-color: #e98b24;
  border-radius: 0;
  background-image: url('../../assets/images/cpv-fundo-4.png');
  object-fit: cover;
  margin-bottom: 0px;

  h1 {
    font-size: 57px;
    font-weight: 400;

    color: #ffffff;

    line-height: 64px;
    letter-spacing: -0.25px;

    text-align: center;
  }

  h3 {
    font-size: 32px;
    font-weight: 400;

    color: #ffffff;

    line-height: 40px;
    letter-spacing: 0;

    text-align: center;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1280px) {
  .header__page {
    background-color: #e98b24;
    border-radius: 0;
    background-image: url('../../assets/images/cpv-fundo-4.png');
    object-fit: cover;
    margin-bottom: 0px;

    h1 {
      font-size: 57px;
      font-weight: 400;

      color: #ffffff;

      line-height: 64px;
      letter-spacing: -0.25px;

      text-align: center;
    }

    h3 {
      font-size: 32px;
      font-weight: 400;

      color: #ffffff;

      line-height: 40px;
      letter-spacing: 0;

      text-align: center;
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  .header__page {
    background-color: #e98b24;
    border-radius: 0;
    background-image: url('../../assets/images/cpv-fundo-4.png');
    object-fit: cover;
    margin-top: 0px !important;
    margin-bottom: 0px;

    h1 {
      font-size: 45px;
      line-height: 52px;
      letter-spacing: 0;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
    }

    h3 {
      font-size: 28px;
      line-height: 36px;
      letter-spacing: 0;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
    }
  }
}

@media only screen and (min-width: 576px) and (max-width: 768px) {
  .header__page {
    background-color: #e98b24;
    border-radius: 0;
    background-image: url('../../assets/images/cpv-fundo-4.png');
    object-fit: cover;
    margin-top: 0px !important;

    h1 {
      font-size: 45px;
      line-height: 52px;
      letter-spacing: 0;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
    }

    h3 {
      font-size: 28px;
      line-height: 36px;
      letter-spacing: 0;

      font-weight: 400;
      color: #ffffff;

      text-align: center;
    }
  }
}

@media only screen and (min-width: 320px) and (max-width: 576px) {
  .header__page {
    background-color: #e98b24;
    border-radius: 0;
    background-image: url('../../assets/images/cpv-fundo-4.png');
    object-fit: cover;
    margin-top: 0px !important;

    h1 {
      font-size: 36px;
      line-height: 44px;
      letter-spacing: 0;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
    }

    h3 {
      font-size: 24px;
      line-height: 32px;
      letter-spacing: 0;

      font-weight: 400;
      color: #ffffff;

      text-align: center;
    }
  }
}
</style>
